import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['carousel'];

    connect() {
        $(this.carouselTargets).each(function () {
            $(this).owlCarousel({
                loop: true,
                margin: 5,
                items: 1,
                dots: false,
                responsiveClass: false,
                autoplayHoverPause: false,
                autoplay: false,
                autoHeight: true,
                nav: true,
                navText: [
                    '<div class=\'nav-btn prev-slide\'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" ><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" /></svg></div>',
                    '<div class=\'nav-btn next-slide\'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" /></svg></div>'
                ],
            });
        });
    }

    disconnect() {
        $(this.carouselTargets).each(function () {
            $(this).owlCarousel().trigger('destroy.owl.carousel');
        });
    }
}
